module.exports = "<p>\n  {{message}}\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/reset-mob/reset-mob.component.html
// module id = ./src/app/shared/reset-mob/reset-mob.component.html
// module chunks = main